import {Typography} from '../typography'
import PropTypes from 'prop-types'
import React from 'react'

// TODO Adnan: update the Banner to follow Material Design guidelines
// https://m2.material.io/components/banners#anatomy
export const Banner = ({type, description, title}) => {
  const colors = {
    error: 'error',
    success: 'success',
    warning: 'primary3',
    info: 'primary2'
  }
  return (
    <div
      style={{
        background: `rgba(var(--mdc-theme-${colors[type]}-rgb),0.1)`,
        padding: '1rem',
        border: `1px solid var(--mdc-theme-${colors[type]})`,
        borderRadius: '0.5rem',
        color: `var(--mdc-theme-${colors[type]})`
      }}>
      {title && (
        <Typography tag="p" use="body-medium-regular">
          {title}
        </Typography>
      )}
      {description && <Typography use="body-small-regular">{description}</Typography>}
    </div>
  )
}
Banner.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  description: PropTypes.string,
  title: PropTypes.string
}
